/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import axios from 'axios'
import ReactHtmlParser from 'react-html-parser'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Divider from '@mui/material/Divider'
import NotesIcon from '@mui/icons-material/Notes'

import { viewFeedbackAndVerdictForItemJSX } from '../../../analysisJSX/viewFeedbackAndVerdictForItemJSX'

import { positionChangeWidthSm, navbarHeight, footerHeight, bumbleProfileImageWidth, bumbleLeadImageHeight, bumbleImageHeight, bumbleProfileBackgroundColor, bumbleProfileItemBorderColor, bumbleProfileItemDividerOpacity, bumbleProfileItemBoxShadow, bumbleProfileItemBorderWidth, bumbleProfileItemBorderRadius, bumbleProfilePromptTextColor, swipelyticsTurquoise, profPicDefaultURL } from '../../../../../helpers/variableDefaults'

export const viewBumblePromptItem = (viewFeedbackTrue, giveFeedbackTrue, promptIndex, datingProfile, width) => {
  // console.log('prompt index ->', promptIndex)
  // console.log('datingProfile ->', datingProfile)
  return (
    <Box
      sx={{
        mt: viewFeedbackTrue || giveFeedbackTrue ? 2 : 0,
        pt: 3,
        pb: viewFeedbackTrue || giveFeedbackTrue ? 0 : 3,
        backgroundColor: 'white',
        width: bumbleProfileImageWidth(width),
        boxShadow: bumbleProfileItemBoxShadow, 
        borderRadius: '0px',
        border: bumbleProfileItemBorderWidth,
        borderColor: bumbleProfileItemBorderColor,
      }}
    >
      {/* Prompt */}
      <Box
        sx={{
          px: 2,
          fontWeight: 'bold',
          color: bumbleProfilePromptTextColor,
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
        }}
      >
        {datingProfile.bio.prompts[promptIndex].prompt}
      </Box>

      {/* Response */}
      <Box
        sx={{
          pt: 1, px: 2,
          pb: (viewFeedbackTrue || giveFeedbackTrue) ? 2 : 0,
          fontWeight: 'bold',
          fontSize: '18px',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
        }}
      >
        {datingProfile.bio.prompts[promptIndex].response}
      </Box>

      {viewFeedbackTrue && datingProfile.bioFeedback.promptsFeedback[promptIndex].feedback.length > 0 && datingProfile.bioFeedback.promptsFeedback[promptIndex].verdict.length > 0 &&
        <Box
          sx={{
            width: bumbleProfileImageWidth(width),
            borderRadius: `0px 0px ${bumbleProfileItemBorderRadius} ${bumbleProfileItemBorderRadius}`,
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start',
          }}
        >
          {/* Divider */}
          <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />

          {/* Feedback and Verdict */}
          {viewFeedbackAndVerdictForItemJSX(datingProfile.bioFeedback.promptsFeedback[promptIndex], 'prompts', datingProfile.type)}

        </Box>
      }

    </Box>
  )
}